import React from 'react';
import { Trans } from 'react-i18next';
import { Subtitle } from 'react-design-components';
import { Box } from '@material-ui/core';
import useHelp from './hooks/useHelp';

const BusinessTypeHelp = () => {
  const { t } = useHelp();
  return (
    <Trans i18nKey="business_type" t={t}>
      <Box mt={4} mb={2}>
        <Subtitle margined>
          Der Typ Ihrer Gewerbefläche ist für die Prüfung der Abrechnung wichtig, da jedes Gewerbe unterschiedliche
          Verbräuche aufweist. Diese sind aber innerhalb einer Branche
          <b>untereinander gut vergleichbar.</b>
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle>
          So fallen bei Gastronomieunternehmen beispielsweise deutlich höhere Kosten für Abwasser und Müll an als bei
          Unternehmen aus anderen Branchen. Zwei Gastro-Unternehmen ähnlicher Größe sind jedoch gut in ein Verhältnis zu
          setzen.
        </Subtitle>
      </Box>
      <Box mb={2}>
        <Subtitle>
          Zahlen Sie für Ihr Gewerbe zu hohe Betriebskosten? Wie hoch sind Ihre Kosten im Verhältnis zu anderen
          Unternehmen Ihrer Größe und Branche?
        </Subtitle>
      </Box>
    </Trans>
  );
};

export default BusinessTypeHelp;
